module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic09.2cebec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic09.png
// module id = 543
// module chunks = 1